import NoMatch from './NoMatch';

export default NoMatch;